import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchValueChainDetail = createAsyncThunk(
  "fetchValueChainDetail",
  async ({ id }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `vc/detail?id=${id}`,
      config
    );
    
    return response.data.data;
  }
);

const valueChainDetailSlice = createSlice({
  name: "valueChainDetail",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
 
  reducers: {
    resetStateValueChainDetail: (state) => {
      state.isLoading = false;
      state.error = null;
      state.data = null;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchValueChainDetail.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchValueChainDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

    });
    builder.addCase(fetchValueChainDetail.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetStateValueChainDetail } = valueChainDetailSlice.actions;
export default valueChainDetailSlice.reducer;